import util from '@/util'
import eventCategories from '@/constant/eventCategories'

function hasExpandedFeedbackPanel(presentationId) {
  return sessionStorage.getItem(`expanded-feedback-panel-${presentationId}`)
}

export default {
  methods: {
    trackFeedbackPanelEvent(eventName, props) {
      util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        eventName,
        null, null,
        this._getTrackingProps(this.presentation, this.slideActive, props),
      )
      util.trackGA4AndMixpanel(eventName, {
        eventCategory: eventCategories.PRESENTATION_EDITOR,
        ...this._getTrackingProps(this.presentation, this.slideActive, props),
      })
    },
    _getTrackingProps(presentation, slideActive, props) {
      return {
        presentationId: presentation.id,
        slideCount: presentation.slides ? presentation.slides.length : null,
        lastSlideType: slideActive.type,
        onlineCount: this.$store.state.userOnline,
        ...props,
      }
    },

    checkToShowFeedbackPanel(isPresentingLastSlide) {
      if (this.revealFeedbackTimeout) {
        clearTimeout(this.revealFeedbackTimeout)
      }

      if (!isPresentingLastSlide) {
        this.isFeedbackPanelOpen = false
        this.isFeedbackPanelCollapsedButtonVisible = false
        return
      }

      let delayTime = 3e3
      // Đến last slide, thì auto đóng QR code panel & mở feedback panel
      // Delay 10s rồi mới hiện, để chắc chắn presenter đang thật sự ở slide cuối, đừng làm họ giật mình
      // Tránh trường hợp họ đến nhầm slide cuối rồi back lại slide trước
      // Nếu slide cuối là quiz/poll, thì đợi cho hết thời gian của câu đó rồi mới hiện cho đỡ confusing
      const isSubmissionSlideType = ['wordCloud', 'question', 'scale', 'pickAnswer', 'imageChoice', 'multipleChoice', 'ideas', 'openEnded'].includes(this.slideActive.type)
      if (isSubmissionSlideType) {
        delayTime = (this.slideActive.timeToAnswer + 3) * 1000
      }
      if (!hasExpandedFeedbackPanel(this.presentation.id) &&
        !isSubmissionSlideType &&
        !this.isStartPresentingFromLastSlide &&
        this.hasMoreThan5Slides
      ) {
        this.revealFeedbackTimeout = setTimeout(() => {
          this.isFeedbackPanelOpen = true
          sessionStorage.setItem('expanded-feedback-panel', true)
          this.trackFeedbackPanelEvent('Private feedback > Expand panel', {
            autoExpand: true,
          })
          this.toggleQRCodePanelAction(false)
        }, delayTime)
      } else {
        this.isFeedbackPanelCollapsedButtonVisible = true
        this.toggleQRCodePanelAction(false)
      }
    },
  },
}
